import { all, spawn } from 'redux-saga/effects'

import appSagas from './app.sagas'
import accountSagas from './account.sagas'
import adminSagas from './admin.sagas'
import addonsSagas from './addons.sagas'
import seoChecklistSagas from './seoChecklist.sagas'
import competitorsSagas from './competitors.sagas'
import userSagas from './user.sagas'
import domainsDataSagas from './domainsData.sagas'
import domainsListSagas from './domainsList.sagas'
import keywordFinderSagas from './keywordFinder.sagas'
import keywordPagesSagas from './keywordPages.sagas'
import keywordGrossingSagas from './keywordGrossing.sagas'
import keywordMetricsSagas from './keywordMetrics.sagas'
import keywordDiscoverySagas from './keywordDiscovery.sagas'
import keywordSavingsSagas from './keywordSavings.sagas'
import keywordSavingsOverviewSagas from './keywordSavingsOverview.sagas'
import keywordsSagas from './keywords.sagas'
import reportsSagas from './reports.sagas'
import serpCheckerSagas from './serpChecker.sagas'
import usersSagas from './users.sagas'
import websiteAuditSagas from './websiteAudit.sagas'
import billingSagas from './billing.sagas'
import dashboardSagas from './dashboard.sagas'
import notificationSagas from './notification.sagas'
import listSagas from './list.sagas'
import tagsSagas from './domainTags.sagas'
import localesSagas from './locales.sagas'
import backlinkCheckerSagas from './backlinkChecker.sagas'

export default function* rootSaga() {
  yield all([
    spawn(appSagas),
    spawn(accountSagas),
    spawn(adminSagas),
    spawn(addonsSagas),
    spawn(seoChecklistSagas),
    spawn(userSagas),
    spawn(domainsDataSagas),
    spawn(domainsListSagas),
    spawn(competitorsSagas),
    spawn(keywordFinderSagas),
    spawn(keywordPagesSagas),
    spawn(keywordGrossingSagas),
    spawn(keywordMetricsSagas),
    spawn(keywordDiscoverySagas),
    spawn(keywordSavingsSagas),
    spawn(keywordSavingsOverviewSagas),
    spawn(keywordsSagas),
    spawn(reportsSagas),
    spawn(serpCheckerSagas),
    spawn(usersSagas),
    spawn(websiteAuditSagas),
    spawn(billingSagas),
    spawn(dashboardSagas),
    spawn(notificationSagas),
    spawn(listSagas),
    spawn(tagsSagas),
    spawn(localesSagas),
    spawn(backlinkCheckerSagas)
  ])
}
